var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("breadcrumb", { attrs: { breadcrumbConfig: _vm.breadcrumbConfig } }),
      _vm._m(0),
      _c("div", { staticClass: "contentDetails" }, [
        _c(
          "div",
          { staticClass: "box" },
          [
            _c("Steps", {
              attrs: { stepInfo: _vm.afterSaleNode, status: _vm.afterSaleNode },
              on: { stepStatus: _vm.stepClick },
            }),
          ],
          1
        ),
      ]),
      _c(
        "div",
        {
          staticClass: "contentDetails",
          staticStyle: { display: "flex", "justify-content": "space-between" },
        },
        [
          _c("div", [
            _vm.afterSaleNode.closeStatus != 1
              ? _c(
                  "div",
                  { staticStyle: { display: "flex", "align-items": "center" } },
                  [
                    _c("img", {
                      staticStyle: { "margin-right": "8px" },
                      attrs: {
                        src:
                          _vm.afterSaleMessage.subsetStatus == 8
                            ? _vm.statusImg.open
                            : _vm.statusImg.close,
                      },
                    }),
                    _c("span", { staticClass: "boldSize" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            (_vm.afterSaleMessage.subsetStatus == 1
                              ? "退款中"
                              : "") ||
                              (_vm.afterSaleMessage.subsetStatus == 2
                                ? "等待客户寄回"
                                : "") ||
                              (_vm.afterSaleMessage.subsetStatus == 3
                                ? "客户已寄回"
                                : "") ||
                              (_vm.afterSaleMessage.subsetStatus == 4
                                ? "等待寄出换货"
                                : "") ||
                              (_vm.afterSaleMessage.subsetStatus == 5
                                ? "换货已寄出"
                                : "") ||
                              (_vm.afterSaleMessage.subsetStatus == 8
                                ? "售后完成"
                                : "")
                          ) +
                          " "
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm.afterSaleNode.closeStatus == 1
              ? _c(
                  "div",
                  { staticStyle: { display: "flex", "align-items": "center" } },
                  [
                    _c("img", {
                      staticStyle: { "margin-right": "8px" },
                      attrs: {
                        src:
                          _vm.afterSaleMessage.subsetStatus == 8
                            ? _vm.statusImg.open
                            : _vm.statusImg.close,
                      },
                    }),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "18px",
                          "font-weight": "bold",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.afterSaleNode.closeStatus == 1
                                ? "售后关闭"
                                : ""
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm.afterSaleMessage.subsetStatus == 1
              ? _c(
                  "div",
                  {
                    staticClass: "approver",
                    staticStyle: { "margin-top": "10px" },
                  },
                  [_vm._v(" 请及时跟进！ ")]
                )
              : _vm._e(),
            _vm.afterSaleMessage.subsetStatus == 8
              ? _c(
                  "div",
                  {
                    staticClass: "approver",
                    staticStyle: { "margin-top": "10px" },
                  },
                  [
                    _vm._v(
                      " 时间：" +
                        _vm._s(
                          _vm.afterSaleMessage.finishedTime
                            ? _vm.afterSaleMessage.finishedTime
                            : "-"
                        ) +
                        " "
                    ),
                  ]
                )
              : _vm._e(),
            _vm.afterSaleMessage.subsetStatus == 6 ||
            _vm.afterSaleMessage.subsetStatus == 7
              ? _c(
                  "div",
                  {
                    staticClass: "approver",
                    staticStyle: { "margin-top": "10px" },
                  },
                  [
                    _vm._v(
                      " 时间：" +
                        _vm._s(
                          _vm.afterSaleMessage.finishedTime
                            ? _vm.afterSaleMessage.finishedTime
                            : "-"
                        ) +
                        " "
                    ),
                  ]
                )
              : _vm._e(),
            _vm.afterSaleMessage.subsetStatus == 2 ||
            _vm.afterSaleMessage.subsetStatus == 3 ||
            _vm.afterSaleMessage.subsetStatus == 4 ||
            _vm.afterSaleMessage.subsetStatus == 5
              ? _c(
                  "div",
                  {
                    staticClass: "approver",
                    staticStyle: { "margin-top": "20px" },
                  },
                  [_vm._v(" 收货信息 ")]
                )
              : _vm._e(),
            _vm.afterSaleMessage.afterSaleMessage == 2 ||
            _vm.afterSaleMessage.subsetStatus == 3 ||
            _vm.afterSaleMessage.subsetStatus == 4 ||
            _vm.afterSaleMessage.subsetStatus == 5 ||
            _vm.afterSaleMessage.subsetStatus == 6 ||
            _vm.afterSaleMessage.subsetStatus == 7
              ? _c(
                  "span",
                  {
                    staticClass: "size14",
                    staticStyle: {
                      "font-weight": "400",
                      color: "#4c81eb",
                      "margin-top": "10px",
                      display: "inline-block",
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.afterSaleMessage.subsetStatus == 2
                            ? "收货方式"
                            : "" || _vm.afterSaleMessage.subsetStatus == 4
                            ? "等待寄出换货"
                            : "" ||
                              (_vm.afterSaleMessage.subsetStatus == 3 ||
                              _vm.afterSaleMessage.subsetStatus == 5
                                ? "运输中"
                                : "") ||
                              (_vm.afterSaleMessage.subsetStatus == 6 ||
                              _vm.afterSaleMessage.subsetStatus == 7
                                ? "关闭原因"
                                : "")
                        ) +
                        " "
                    ),
                  ]
                )
              : _vm._e(),
            _vm.afterSaleMessage.subsetStatus == 2 ||
            _vm.afterSaleMessage.subsetStatus == 4
              ? _c(
                  "span",
                  {
                    staticClass: "size14",
                    staticStyle: {
                      "margin-left": "20px",
                      "margin-top": "8px",
                      "font-weight": "400",
                      color: "#999999",
                      display: "inline-block",
                    },
                  },
                  [_c("span", [_vm._v("使用物流配送")])]
                )
              : _vm._e(),
            _vm.afterSaleMessage.subsetStatus == 3
              ? _c(
                  "span",
                  {
                    staticClass: "size14",
                    staticStyle: {
                      "margin-top": "8px",
                      "margin-left": "20px",
                      "font-weight": "400",
                      color: "#999999",
                    },
                  },
                  [
                    _c("span", [_vm._v(_vm._s(_vm.salesReturn.expTextName))]),
                    _c("span", { staticStyle: { "margin-left": "5px" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.salesReturn.mailNo ? _vm.salesReturn.mailNo : "-"
                        )
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm.afterSaleMessage.subsetStatus == 5
              ? _c(
                  "span",
                  {
                    staticClass: "size14",
                    staticStyle: {
                      "margin-top": "8px",
                      "margin-left": "20px",
                      "font-weight": "400",
                      color: "#999999",
                    },
                  },
                  [
                    _c("span", [
                      _vm._v(_vm._s(_vm.exchangeGoodsList.expTextName)),
                    ]),
                    _c("span", { staticStyle: { "margin-left": "5px" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.exchangeGoodsList.mailNo
                            ? _vm.exchangeGoodsList.mailNo
                            : "-"
                        )
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm.afterSaleMessage.subsetStatus == 6 ||
            _vm.afterSaleMessage.subsetStatus == 7
              ? _c(
                  "span",
                  {
                    staticClass: "size14",
                    staticStyle: {
                      "margin-top": "8px",
                      "margin-left": "20px",
                      "font-weight": "400",
                      color: "#999999",
                    },
                  },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.afterSaleMessage.closeReason
                            ? _vm.afterSaleMessage.closeReason
                            : "-"
                        )
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
          ]),
          _c(
            "div",
            { staticClass: "logisticsBtn" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "medium", plain: "" },
                  on: { click: _vm.examine },
                },
                [_vm._v("查看物流")]
              ),
              _vm.afterSaleMessage.subsetStatus == 4
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "medium", plain: "" },
                      on: { click: _vm.sendOff },
                    },
                    [_vm._v("寄出换货")]
                  )
                : _vm._e(),
              _vm.afterSaleMessage.subsetStatus == 2 &&
              _vm.orderMessage.sysUserId == _vm.userId
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "medium", plain: "" },
                      on: { click: _vm.sendBack },
                    },
                    [_vm._v("商品寄回")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _c("div", { staticClass: "contentDetails" }, [
        _c("div", { staticClass: "title" }, [_vm._v("订单信息")]),
        _c("div", { staticClass: "order_details" }, [
          _c("div", { staticClass: "order_details_box" }, [
            _c("div", { staticClass: "order_details_item" }, [
              _c("span", { staticClass: "order_details_title" }, [
                _vm._v("订单号"),
              ]),
              _c("span", { staticClass: "order_details_value" }, [
                _vm._v(
                  _vm._s(
                    _vm.orderMessage.orderNo ? _vm.orderMessage.orderNo : "-"
                  )
                ),
              ]),
            ]),
            _c("div", { staticClass: "order_details_item" }, [
              _c("span", { staticClass: "order_details_title" }, [
                _vm._v("关联订单号"),
              ]),
              _c("span", { staticClass: "order_details_value" }, [
                _vm._v(
                  _vm._s(
                    _vm.orderMessage.platformOrderNo
                      ? _vm.orderMessage.platformOrderNo
                      : "-"
                  )
                ),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "blankBox" }),
          _c("div", { staticClass: "order_details_box" }, [
            _c("div", { staticClass: "order_details_item" }, [
              _c("span", { staticClass: "order_details_title" }, [
                _vm._v("订单类型"),
              ]),
              _c("span", { staticClass: "order_details_value" }, [
                _vm._v(
                  _vm._s(
                    _vm.orderMessage.orderTypeLabel
                      ? _vm.orderMessage.orderTypeLabel
                      : "-"
                  )
                ),
              ]),
            ]),
            _c("div", { staticClass: "order_details_item" }, [
              _c("span", { staticClass: "order_details_title" }, [
                _vm._v("入线时间"),
              ]),
              _c("span", { staticClass: "order_details_value" }, [
                _vm._v(
                  _vm._s(
                    _vm.orderMessage.ditchTime
                      ? _vm.orderMessage.ditchTime
                      : "-"
                  )
                ),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "blankBox" }),
          _c("div", { staticClass: "order_details_box" }, [
            _c("div", { staticClass: "order_details_item" }, [
              _c("span", { staticClass: "order_details_title" }, [
                _vm._v("支付方式"),
              ]),
              _c("span", { staticClass: "order_details_value" }, [
                _vm._v(
                  _vm._s(
                    _vm.orderMessage.payTypeCN
                      ? _vm.orderMessage.payTypeCN
                      : "-"
                  )
                ),
              ]),
            ]),
            _c("div", { staticClass: "order_details_item" }, [
              _c("span", { staticClass: "order_details_title" }, [
                _vm._v("跟进客服"),
              ]),
              _c("span", { staticClass: "order_details_value" }, [
                _vm._v(
                  _vm._s(
                    _vm.orderMessage.follower ? _vm.orderMessage.follower : "-"
                  )
                ),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "blankBox" }),
          _c("div", { staticClass: "order_details_box" }, [
            _c("div", { staticClass: "order_details_item" }, [
              _c("span", { staticClass: "order_details_title" }, [
                _vm._v("平台"),
              ]),
              _c("span", { staticClass: "order_details_value" }, [
                _vm._v(
                  _vm._s(
                    _vm.orderMessage.platformName
                      ? _vm.orderMessage.platformName
                      : "-"
                  )
                ),
              ]),
            ]),
            _c("div", { staticClass: "order_details_item" }, [
              _c("span", { staticClass: "order_details_title" }, [
                _vm._v("部门"),
              ]),
              _c("span", { staticClass: "order_details_value" }, [
                _vm._v(
                  _vm._s(
                    _vm.orderMessage.orgName ? _vm.orderMessage.orgName : "-"
                  )
                ),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "blankBox" }),
          _c("div", { staticClass: "order_details_box" }, [
            _c("div", { staticClass: "order_details_item" }, [
              _c("span", { staticClass: "order_details_title" }, [
                _vm._v("来源渠道"),
              ]),
              _c("span", { staticClass: "order_details_value" }, [
                _vm._v(
                  _vm._s(
                    _vm.orderMessage.userDitch
                      ? _vm.orderMessage.userDitch
                      : "-"
                  )
                ),
              ]),
            ]),
            _c("div", { staticClass: "order_details_item" }, [
              _c("span", { staticClass: "order_details_title" }, [
                _vm._v("订单分类"),
              ]),
              _c("span", { staticClass: "order_details_value" }, [
                _vm._v(
                  _vm._s(
                    _vm.orderMessage.orderGenerateTypeLabel
                      ? _vm.orderMessage.orderGenerateTypeLabel
                      : "-"
                  )
                ),
              ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "remarkMessage" }, [
          _c("div", { staticClass: "remarkMessage_remark" }, [
            _c("div", { staticClass: "remarkMessage_remark_item" }, [
              _c("span", { staticClass: "fourteenTitle" }, [
                _vm._v("备注信息"),
              ]),
              _c("span", { staticClass: "fourteenDetails" }, [
                _vm._v(
                  _vm._s(
                    _vm.orderMessage.remarks
                      ? _vm.orderMessage.remarks
                      : "暂无备注 "
                  )
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "contentDetails" }, [
        _c("div", { staticClass: "title" }, [_vm._v("购买信息")]),
        _c("div", { staticClass: "contentDetails_box" }, [
          _c("div", { staticClass: "contentDetails_item" }, [
            _c("div", { staticClass: "title_too" }, [_vm._v("收货信息")]),
            _c("div", { staticClass: "details" }, [
              _c("div", { staticClass: "details_item" }, [
                _c("span", { staticClass: "details_title fourteen" }, [
                  _vm._v("收货人"),
                ]),
                _c("span", { staticClass: "details_value fourteen" }, [
                  _vm._v(
                    _vm._s(
                      _vm.buyMessage.postName ? _vm.buyMessage.postName : "-"
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "details_item" }, [
                _c("span", { staticClass: "details_title fourteen" }, [
                  _vm._v("联系方式"),
                ]),
                _c("span", { staticClass: "details_value fourteen" }, [
                  _vm._v(
                    _vm._s(
                      _vm.buyMessage.postContact
                        ? _vm.buyMessage.postContact
                        : "-"
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "details_item addressWidth" }, [
                _c("span", { staticClass: "details_title fourteen" }, [
                  _vm._v("收货地址"),
                ]),
                _c("span", { staticClass: "details_value fourteen" }, [
                  _vm._v(
                    _vm._s(
                      (_vm.buyMessage.postProvinceCode
                        ? _vm.buyMessage.postProvinceCode
                        : "") +
                        (_vm.buyMessage.postCityCode != null
                          ? _vm.buyMessage.postCityCode
                          : "") +
                        _vm.buyMessage.postDetailedAddress
                    )
                  ),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "borderWire" }),
          _c("div", { staticClass: "contentDetails_item" }, [
            _c("div", { staticClass: "title_too" }, [_vm._v("买家信息")]),
            _c("div", { staticClass: "details" }, [
              _c("div", { staticClass: "details_item" }, [
                _c("span", { staticClass: "details_title fourteen" }, [
                  _vm._v("客户姓名"),
                ]),
                _c("span", { staticClass: "details_value fourteen" }, [
                  _vm._v(
                    _vm._s(
                      _vm.buyMessage.userName ? _vm.buyMessage.userName : "-"
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "details_item" }, [
                _c("span", { staticClass: "details_title fourteen" }, [
                  _vm._v("客户电话"),
                ]),
                _c("span", { staticClass: "details_value fourteen" }, [
                  _vm._v(
                    _vm._s(
                      _vm.buyMessage.userPhone ? _vm.buyMessage.userPhone : "-"
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "details_item" }, [
                _c("span", { staticClass: "details_title fourteen" }, [
                  _vm._v("客户意向"),
                ]),
                _c("span", { staticClass: "details_value fourteen" }, [
                  _vm._v(
                    _vm._s(
                      _vm.buyMessage.userIntentionLabel
                        ? _vm.buyMessage.userIntentionLabel
                        : "-"
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "details_item" }, [
                _c("span", { staticClass: "details_title fourteen" }, [
                  _vm._v("买家留言"),
                ]),
                _c("span", { staticClass: "details_value fourteen" }, [
                  _vm._v(
                    _vm._s(
                      _vm.buyMessage.userRemarks
                        ? _vm.buyMessage.userRemarks
                        : "-"
                    )
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "contentDetails" },
        [
          _vm._m(1),
          _c(
            "el-table",
            {
              staticClass: "goodsMessage",
              attrs: {
                data: _vm.goodsList,
                "header-cell-style": {
                  background: "#fafafa",
                  color: "#333333",
                },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "updatedTime",
                  label: "商品信息",
                  headerAlign: "left",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c("div", { staticStyle: { "text-align": "left" } }, [
                          _c("p", [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  props.row.goodsName
                                    ? props.row.goodsName
                                    : "-"
                                )
                              ),
                            ]),
                            props.row.goodsType == 3
                              ? _c("span", { staticClass: "gift" }, [
                                  _vm._v("赠品"),
                                ])
                              : _vm._e(),
                          ]),
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                props.row.goodsSkuName
                                  ? props.row.goodsSkuName
                                  : "-"
                              )
                            ),
                          ]),
                          _c("p", [
                            _c(
                              "span",
                              { staticStyle: { "padding-right": "10px" } },
                              [_vm._v("商品编码")]
                            ),
                            _vm._v(
                              _vm._s(
                                props.row.goodsSkuNo
                                  ? props.row.goodsSkuNo
                                  : "-"
                              )
                            ),
                          ]),
                          _c("p", [
                            _c(
                              "span",
                              { staticStyle: { "padding-right": "10px" } },
                              [_vm._v("商家编码")]
                            ),
                            _vm._v(
                              _vm._s(
                                props.row.merchantCode
                                  ? props.row.merchantCode
                                  : "-"
                              )
                            ),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "authListStr",
                  label: "单价/数量",
                  "header-align": "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c("div", { staticStyle: { "text-align": "right" } }, [
                          _c("p", [
                            _vm._v("￥ " + _vm._s(props.row.unitPrice)),
                          ]),
                          _c("p", [_vm._v("× " + _vm._s(props.row.quantity))]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "authListStr",
                  label: "小计",
                  "header-align": "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c("div", { staticStyle: { "text-align": "right" } }, [
                          _vm._v(
                            " ￥ " +
                              _vm._s(
                                Number(
                                  props.row.quantity * props.row.unitPrice -
                                    props.row.discountAmount
                                )
                              ) +
                              " "
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "authListStr",
                  label: "优惠信息",
                  "header-align": "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c("div", { staticStyle: { "text-align": "right" } }, [
                          _c("span", { staticClass: "platform" }, [
                            _vm._v("平台优惠："),
                          ]),
                          _c("span", { staticClass: "platformMoney" }, [
                            _vm._v("￥" + _vm._s(props.row.discountAmount)),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("div", { staticClass: "total_prices" }, [
            _c(
              "span",
              { staticStyle: { color: "#666666", "margin-right": "15px" } },
              [
                _vm._v(
                  "商品总价：￥" +
                    _vm._s(_vm.afterSaleMessage.productTotalAmalgam)
                ),
              ]
            ),
            _c(
              "span",
              { staticStyle: { color: "#666666", "margin-right": "15px" } },
              [_vm._v("运费：￥0")]
            ),
            _c(
              "span",
              { staticStyle: { color: "red", "margin-right": "15px" } },
              [_vm._v("优惠：￥0")]
            ),
            _c(
              "span",
              { staticStyle: { color: "#444", "margin-right": "15px" } },
              [
                _vm._v(
                  "应付：￥" + _vm._s(_vm.afterSaleMessage.receivableAmount)
                ),
              ]
            ),
            _c(
              "span",
              { staticStyle: { color: "#6190ed", "margin-right": "15px" } },
              [
                _vm._v(
                  "（实付：￥" +
                    _vm._s(_vm.afterSaleMessage.receivedAmount) +
                    "）"
                ),
              ]
            ),
            _c("span", { staticStyle: { color: "red" } }, [
              _vm._v(
                "退款金额：￥" + _vm._s(_vm.afterSaleMessage.refundAmount)
              ),
            ]),
          ]),
          _c("div", { staticClass: "afterSaleBox" }, [
            _vm._m(2),
            _c("div", { staticClass: "afterSaleBox_item" }, [
              _c("div", { staticClass: "message" }, [
                _c("p", [
                  _c("span", [_vm._v("退款编号:")]),
                  _c("span", { staticClass: "message_value" }, [
                    _vm._v(_vm._s(_vm.afterSaleMessage.afterNo)),
                  ]),
                ]),
                _c("p", [
                  _c("span", [_vm._v("售后原因:")]),
                  _c("span", { staticClass: "message_value" }, [
                    _vm._v(_vm._s(_vm.afterSaleMessage.refundCause)),
                  ]),
                ]),
                _c("p", [
                  _c("span", [_vm._v("售后说明:")]),
                  _c("span", { staticClass: "message_value" }, [
                    _vm._v(
                      _vm._s(
                        this.afterSaleMessage.refundReason
                          ? this.afterSaleMessage.refundReason
                          : "-"
                      )
                    ),
                  ]),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "imgbox" },
                [
                  _c("span", { staticClass: "imgbox_title" }, [
                    _vm._v("图片："),
                  ]),
                  _vm._l(
                    _vm.afterSaleMessage.imageListen,
                    function (item, index) {
                      return _c("el-image", {
                        key: index,
                        staticClass: "img_item",
                        attrs: {
                          "preview-src-list": _vm.afterSaleMessage.imageListen,
                          src: item,
                          lazy: "",
                        },
                      })
                    }
                  ),
                ],
                2
              ),
            ]),
            _c("div", { staticClass: "tuikuan" }, [
              _c("span", { staticClass: "tuikuan_status" }, [
                _vm._v(
                  _vm._s(
                    _vm.type == "accomplish"
                      ? "退款成功"
                      : "" || _vm.type == "afterSaleclose"
                      ? "退款失败"
                      : ""
                  )
                ),
              ]),
              _c("span", { staticClass: "money" }, [
                _vm._v(
                  "退款金额:￥" + _vm._s(_vm.afterSaleMessage.refundAmount)
                ),
              ]),
            ]),
          ]),
        ],
        1
      ),
      _c("div", { staticClass: "botton_btn" }, [
        (_vm.approveStatus || _vm.afterSaleMessage.subsetStatus == 1) &&
        _vm.parArray.indexOf("afterAuditCode") != -1 &&
        this.auditState == true
          ? _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    staticClass: "whiteBtn",
                    attrs: { type: "primary", plain: "" },
                    on: { click: _vm.handlerAudit },
                  },
                  [_vm._v("审核")]
                ),
              ],
              1
            )
          : _vm._e(),
        _vm.afterSaleMessage.subsetStatus != 6 &&
        _vm.afterSaleMessage.subsetStatus != 7 &&
        _vm.afterSaleMessage.subsetStatus != 8 &&
        _vm.orderMessage.sysUserId == _vm.userId &&
        _vm.parArray.indexOf("disqualificationCode") != -1
          ? _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    staticStyle: {
                      width: "120px",
                      height: "36px",
                      "line-height": "0",
                    },
                    attrs: { type: "primary" },
                    on: { click: _vm.cancelAfterSale },
                  },
                  [_vm._v("取消售后")]
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": true,
            title: _vm.dialog.title,
            visible: _vm.dialog.visible,
            width: _vm.dialog.width,
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
          },
        },
        [
          _vm.dialog.type == "logisticsInformation"
            ? [
                _c("StepLogistics", {
                  attrs: {
                    stepProgress:
                      _vm.afterSaleMessage.subsetStatus == 3
                        ? _vm.salesReturn
                        : _vm.exchangeGoodsList,
                  },
                }),
              ]
            : _vm._e(),
          _vm.dialog.type == "logisticsInformationTwo"
            ? [
                _c("StepLogistics", {
                  attrs: {
                    stepProgress:
                      _vm.stepClickType == 3
                        ? _vm.salesReturn
                        : _vm.exchangeGoodsList,
                  },
                }),
              ]
            : _vm._e(),
          _vm.dialog.type == "addRemark"
            ? [
                _c(
                  "el-form",
                  { attrs: { "label-width": "50px" } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "备注" } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            placeholder: "请输入内容",
                          },
                          model: {
                            value: _vm.remark,
                            callback: function ($$v) {
                              _vm.remark = $$v
                            },
                            expression: "remark",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "dialogBtn" },
                  [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            _vm.dialog.visible = false
                          },
                        },
                      },
                      [_vm._v("取 消")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.confirm },
                      },
                      [_vm._v("确 定")]
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.dialog.type == "audit"
            ? [
                _c("div", { staticClass: "audit_title" }, [
                  _vm._v("是否审核通过？"),
                ]),
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.shenhe,
                      callback: function ($$v) {
                        _vm.shenhe = $$v
                      },
                      expression: "shenhe",
                    },
                  },
                  [
                    _c("el-radio", { attrs: { label: "2" } }, [_vm._v("通过")]),
                    _c("el-radio", { attrs: { label: "3" } }, [
                      _vm._v("不通过"),
                    ]),
                  ],
                  1
                ),
                _vm.shenhe == 3
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-form",
                          {
                            staticClass: "audit_textarea",
                            attrs: { "label-width": "40px" },
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "原因" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: "请输入原因",
                                    maxlength: "200",
                                    "show-word-limit": "",
                                    type: "textarea",
                                  },
                                  model: {
                                    value: _vm.cause,
                                    callback: function ($$v) {
                                      _vm.cause = $$v
                                    },
                                    expression: "cause",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass: "dialogBtnright",
                    staticStyle: { "margin-top": "20px" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "setPay_payment_btn_quxiao",
                        on: { click: _vm.handleClose },
                      },
                      [_vm._v("取 消")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "setPay_payment_btn_queren",
                        attrs: { type: "primary" },
                        on: { click: _vm.confirmSelectPay },
                      },
                      [_vm._v("确 定")]
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.dialog.type == "exchangeGoods" ||
          _vm.dialog.type == "modifyOrderNoOneTui"
            ? [
                _c("modify-order-no", {
                  ref: "modifyOrderNo",
                  attrs: { afterId: _vm.routeQuery.id, type: _vm.dialog.type },
                  on: { submitState: _vm.modifyState },
                }),
                _c(
                  "div",
                  {
                    staticClass: "dialogBtnright",
                    staticStyle: { "margin-top": "20px" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "setPay_payment_btn_quxiao",
                        on: { click: _vm.closeDialog },
                      },
                      [_vm._v("取 消")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "setPay_payment_btn_queren",
                        attrs: { type: "primary" },
                        on: { click: _vm.actionDialog },
                      },
                      [_vm._v("确 定")]
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "contentDetails" }, [
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "justify-content": "space-between",
            "align-items": "center",
          },
        },
        [_c("div", { staticClass: "title titleblue" }, [_vm._v("售后详情")])]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "titleBtn" }, [
      _c(
        "div",
        { staticClass: "title", staticStyle: { "margin-bottom": "20px" } },
        [_vm._v("商品信息")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "afterSaleBox_item" }, [
      _c("div", { staticClass: "afterSaleBox_title" }, [_vm._v("售后信息")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }